import React, { useEffect, useState, Suspense } from "react";

import parse from "html-react-parser";
import "../../App.css";

import MainBanner from './MainBanner'

const SALONAPI = process.env.REACT_APP_SOMPROP_API_EXTERNAL;

const Home = () => {
 
  const [salonInfo, setSalonInfo] = useState(null);
  const [loading, setLoading] = useState(true);
 
  const [error, setError] = useState(null);

  useEffect(() => {
    const fetchData = async (url) => {
      try {
        const response = await fetch(url);
        if (!response.ok) {
          throw new Error(`HTTP error! status: ${response.status}`);
          
        }
        const data = await response.json();
        setLoading(false)
        setSalonInfo(data["website_settings"]);
      } catch (error) {
        setError(error.message);
        setLoading(true)
        console.error("Error in fetching salon info:", error);
      } finally {
    
      }
    };

    const apiUrl = `${SALONAPI}/homewebsettings`;
    fetchData(apiUrl);
  }, []);

  if (loading) {
    return <div class="loader">
    <div class="loaderin">
    <span class="loader-circle"></span>
    </div>
    </div>    
  }

  if (error) {
    return <div>Error: {error}</div>;
  }

  

  return (
    <>
        
        <Suspense >
          <MainBanner/>
        </Suspense>

     

      <div id="parallax"></div>
      <div className="parallax-section" id="parallax_section">
        {salonInfo && parse(salonInfo.parallax_section && (salonInfo.parallax_section || ''))}
      </div>
      <div className="count-section">
        <div className="row" id="home_count_section">
          {salonInfo && parse(salonInfo.home_count_section && (salonInfo.home_count_section || ''))}
        </div>
      </div>
    </>
  );
};

export default Home;
